<template>
    <div>
        <organizational :nest="true" v-if="tenantManager"></organizational>
        <OrgAndNumber module='user' v-else></OrgAndNumber>
    </div>
</template>
<script>
import OrgAndNumber from './components/orgAndNumber.vue'
import organizational from '../../user/organizational.vue'
export default {
    components:{
        OrgAndNumber,
        organizational
    },
    data() {
        return {
            tenantManager: null
        }
    },
    mounted() {
        // 租户管理员角色
        this.tenantManager = this.$store.state.login.roles.some(item=>item.authority=='TENANT_MANAGER')
    }
}
</script>